import React, { useEffect, useState } from 'react'
import { Box, Button, Typography } from '@mui/material';
import { ImportProgressBar } from '../../../Component/Common/Components/ProgressBar/ImportProgressBar';
import { MicroLoading } from '../../../Component/Common/Components/Loading/IntermediateLoading';
import { ProgressData } from '../ImportModal/WSPImportModal';
import { useParams } from 'react-router';
import { HubConnection, HubConnectionBuilder, JsonHubProtocol, LogLevel } from '@microsoft/signalr';
import config from '../../../config';
import { toast } from 'react-toastify';
import { MerSETAReportService } from '../../../Component/Api/WSPReport/MerSETAReportService';
import { MerSETAReportPreview } from './MerSETAReportPreview';
import { IntermediateGlobalLoading } from '../../../Component/Common/Components/Loading/IntermediateGlobalLoading';
import moment from 'moment';
import { TabContext, TabPanel } from '@mui/lab';
import { SimpleTab } from '../../../Component/Common/Components/Tabs/SimpleTab';

export const MerSETAReport = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { WSPScorecardId } = useParams<{ WSPScorecardId: string }>();
    const [connection, setConnection] = useState<null | HubConnection>(null);
    const [isUpdating, setIsUpdating] = useState<boolean>(false);
    const [progress, setProgress] = useState(0);
    const [lastPopulatedDate, setLastPopulatedDate] = useState<Date | null>(null);
    const [progressData, setProgressData] = useState<ProgressData>({
        progress: progress,
        numberOfRowsCorrect: 0,
        numberOfRowsFailed: 0,
        log: [],
        isSuccess: true,
    });
    const reportType = window.location.toString().includes("WSPReport") ? 2 : 1;
    const heading = reportType === 2 ? "WSP Report" : "ATR Report";

    const routes = [
        `/previewReport`,
        `/previewReportErrors`,
    ];
    const labels = ['Report', 'Errors'];

    const tabsData = routes.map((route, index) => ({
        label: labels[index],
        route: labels[index]
    }));

    const [currentTab, setCurrentTab] = React.useState('Report');

    const handleChange = (newValue: string) => {
        setCurrentTab(newValue);
    };

    const populateDataUpdate = async () => {
        setIsUpdating(true);
        await MerSETAReportService.populate(WSPScorecardId, reportType);
    }

    const signalR = async () => {
        try {
            const connect = new HubConnectionBuilder()
                .withUrl(config.populateFunctionAppUrl)
                .withHubProtocol(new JsonHubProtocol())
                .configureLogging(LogLevel.Information)
                .withAutomaticReconnect()
                .build();

            await connect.start();

            setConnection(connect);
        } catch (e: any) {
            console.log(e);
        }
    }

    const getLastPopulatedDate = async () => {
        setIsLoading(true);
        try {
            const lastPopulatedDate = await MerSETAReportService.getLastPopulateDate(WSPScorecardId, reportType);
            if (lastPopulatedDate.data) {
                setLastPopulatedDate(lastPopulatedDate.data);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        getLastPopulatedDate();
        signalR();
        return () => {
            connection?.stop();
        };
    }, []);

    useEffect(() => {
        if (connection) {
            connection.on(`wspAtrReportPopulateReceived-${WSPScorecardId}`, () => {
                setIsUpdating(true);
                setProgress(10);
            })
            connection.on(`wspAtrReportPopulateStarting-${WSPScorecardId}`, () => {
                setProgress(50);
            })
            connection.on(`wspAtrReportPopulateFailed-${WSPScorecardId}`, () => {
                toast.error("Update failed");
                setProgress(0);
                setIsUpdating(false);
            })
            connection.on(`wspAtrReportPopulateCompleted-${WSPScorecardId}`, () => {
                setProgress(100);
                setTimeout(function () {
                    toast.success("Successfully updated " + heading);
                    setProgress(0);
                    getLastPopulatedDate();
                    setIsUpdating(false);
                }, 3000);
            })
        }
        return () => {
            connection?.stop();
        }
    }, [connection]);

    if (isLoading) {
        return <IntermediateGlobalLoading />
    }
    const formattedDate: string = moment(lastPopulatedDate).format('DD MMMM YYYY [at] HH:mm');
    const lastPopulatedMessage = lastPopulatedDate != null ? `Your report was last populated on ${formattedDate}. If you have made changes to your data in Platform for this reporting period, please populate your report again.`
        : 'You have not populated your report yet. Please populate your report once you have data in Platform for this reporting period.'
    return (
        <>
            <Typography variant="h4" style={{ paddingBottom: "20px" }}>
                {heading}
            </Typography>
            <Box>
                <Typography variant="body2" style={{ paddingBottom: "10px" }} key={`isLoading-${isLoading}`}>
                    {lastPopulatedMessage}
                    <br />
                    <Button sx={{ marginTop: '8px' }} variant="contained" hidden={isUpdating} onClick={() => {
                        populateDataUpdate();
                    }} size="small">UPDATE NOW</Button>
                    {isUpdating &&
                        <MicroLoading />
                    }
                </Typography>
                {isUpdating &&
                    <Box mt={2}>
                        <ImportProgressBar
                            value={progress}
                            progressData={progressData}
                        />
                    </Box>
                }
            </Box>
            <TabContext value={currentTab}>
                <SimpleTab currentTab={currentTab} tabsData={tabsData} noRedirect={true} onChange={handleChange} />

                <TabPanel style={{ width: '100%', padding: '0px' }} value={tabsData[0].route}>
                    <MerSETAReportPreview isErrorReport={false} key={`${isUpdating}-refresh`} reportType={reportType} />
                </TabPanel>
                <TabPanel style={{ width: '100%', padding: '0px' }} value={tabsData[1].route}>
                    <MerSETAReportPreview isErrorReport={true} key={`${isUpdating}-refresh`} reportType={reportType} />
                </TabPanel>
            </TabContext>

        </>
    )
}

